jQuery(document).ready(function () {
    if (jQuery('body').hasClass('wm-contact')) {
        var contentOffset = jQuery('.wm-contact__first').offset().top;
        jQuery(document).scroll(function () {
            if (contentOffset < jQuery(window).scrollTop()) {
                jQuery('.wm-contact__navigation').addClass('-fixed');
            }
            else {
                jQuery('.wm-contact__navigation').removeClass('-fixed');
            }
            if ((jQuery('.wm-contact__navigation').offset().top + jQuery('.wm-contact__navigation').height()) + 60 > jQuery('#footer').offset().top) {
                jQuery('.wm-contact__navigation').addClass('-hidden');
            }
            else {
                jQuery('.wm-contact__navigation').removeClass('-hidden');
            }
        });
    }
});
